import { api } from '@/lib/axios';

export interface Recording {
  id: string;
  meetingId: string;
  startedById: string;
  type: 'LOCAL' | 'CLOUD';
  status: 'STARTING' | 'RECORDING' | 'PAUSED' | 'PROCESSING' | 'COMPLETED' | 'FAILED';
  fileSize: number;
  durationSecs: number;
  startedAt: string | null;
  endedAt: string | null;
  createdAt: string;
  downloadUrl?: string;
}

export const recordingApi = {
  async start(meetingId: string): Promise<Recording> {
    const { data } = await api.post('/recordings/start', { meetingId });
    return data.data.recording;
  },
  async pause(id: string): Promise<Recording> {
    const { data } = await api.post(`/recordings/${id}/pause`);
    return data.data.recording;
  },
  async resume(id: string): Promise<Recording> {
    const { data } = await api.post(`/recordings/${id}/resume`);
    return data.data.recording;
  },
  async stop(id: string): Promise<Recording> {
    const { data } = await api.post(`/recordings/${id}/stop`);
    return data.data.recording;
  },
  async list(page = 1): Promise<{ recordings: Recording[]; total: number }> {
    const { data } = await api.get('/recordings', { params: { page } });
    return { recordings: data.data.recordings, total: data.meta?.total ?? 0 };
  },
  async download(id: string): Promise<string> {
    const { data } = await api.get(`/recordings/${id}/download`);
    return data.data.downloadUrl as string;
  },
};
